// ===============================================
// 💳 СБП SERVICE (ЧЕРЕЗ БЭКЕНД API)
// ===============================================

import backendApiService from './backend-api.service';

const sbpService = {
  // ===============================================
  // 🔗 СОЗДАНИЕ QR-КОДА
  // ===============================================

  // Создание QR-кода для оплаты через бэкенд
  async createQRCode(amount, steamAccount) {
    try {
      console.log('🔗 СОЗДАНИЕ QR-КОДА СБП ЧЕРЕЗ БЭКЕНД:', {
        amount: amount,
        steamAccount: steamAccount,
        timestamp: new Date().toISOString()
      });
      
      const result = await backendApiService.createSBPQR(amount, steamAccount);
      
      console.log('✅ QR-КОД СБП СОЗДАН ЧЕРЕЗ БЭКЕНД:', {
        orderId: result.orderId,
        success: result.success,
        hasQrCode: !!result.qrCode,
        hasPaymentUrl: !!result.paymentUrl,
        timestamp: new Date().toISOString()
      });
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка создания QR-кода СБП:', error);
      return {
        success: false,
        message: 'Ошибка создания QR-кода СБП',
        error: error.message
      };
    }
  },

  // ===============================================
  // СОЗДАНИЕ КРИПТОПЛАТЕЖА
  // ===============================================

  // Создание криптоплатежа через бэкенд
  async createCryptoPayment(steamAccount, amountUSD, onProgress) {
    try {
      console.log('СОЗДАНИЕ КРИПТОПЛАТЕЖА ЧЕРЕЗ БЭКЕНД:', {
        steamAccount: steamAccount,
        amountUSD: amountUSD,
        timestamp: new Date().toISOString()
      });
      
      // Имитация прогресса
      if (onProgress) {
        onProgress(10, 'Проверка данных...');
        await new Promise(resolve => setTimeout(resolve, 500));
        
        onProgress(30, 'Создание криптоадреса...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        onProgress(70, 'Генерация QR-кода...');
        await new Promise(resolve => setTimeout(resolve, 500));
        
        onProgress(90, 'Финализация...');
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      
      const result = await backendApiService.createCryptoPayment(amountUSD, steamAccount);
      
      if (onProgress) {
        onProgress(100, 'Криптоплатеж готов!');
      }
      
      console.log('✅ КРИПТОПЛАТЕЖ СОЗДАН ЧЕРЕЗ БЭКЕНД:', {
        orderId: result.orderId,
        success: result.success,
        cryptoAmount: result.cryptoAmount,
        hasCryptoAddress: !!result.cryptoAddress,
        timestamp: new Date().toISOString()
      });
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка создания криптоплатежа:', error);
      return {
        success: false,
        message: 'Ошибка создания криптоплатежа',
        error: error.message
      };
    }
  },

  // ===============================================
  // 🔍 ПРОВЕРКА СТАТУСА
  // ===============================================

  // Проверка статуса платежа через бэкенд
  async checkPaymentStatus(paymentGuid) {
    try {
      console.log('🔍 Проверка статуса платежа СБП через бэкенд:', paymentGuid);
      
      const result = await backendApiService.checkSBPPaymentStatus(paymentGuid);
      
      console.log('✅ Статус платежа СБП получен:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки статуса СБП:', error);
      return {
        success: false,
        message: 'Ошибка проверки статуса платежа',
        error: error.message
      };
    }
  },


  // ===============================================
  // 🔗 WEBHOOK
  // ===============================================

  // Проверка статуса webhook через бэкенд
  async checkWebhookStatus() {
    try {
      console.log('🔗 Проверка статуса webhook СБП через бэкенд...');
      
      const result = await backendApiService.checkWebhookStatus();
      
      console.log('✅ Статус webhook СБП:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки webhook СБП:', error);
      return {
        success: false,
        message: 'Ошибка проверки webhook',
        error: error.message
      };
    }
  },

  // ===============================================
  // 🛠️ УТИЛИТЫ
  // ===============================================

  // Генерация visitorId для СБП
  generateVisitorId() {
    return 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  },


  // Генерация уникального ID платежа
  generatePaymentId() {
    return `sbp_payment_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  // Форматирование суммы в рублях
  formatAmount(amount) {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 2
    }).format(amount);
  },

  // Получение курсов валют
  async getCurrencyRates() {
    try {
      const response = await fetch(`${this.baseUrl}/api/currency/rates`);
      if (response.ok) {
        const data = await response.json();
        return data.rates;
      }
      return null;
    } catch (error) {
      console.error('❌ Ошибка получения курсов валют:', error);
      return null;
    }
  },

  // Конвертация USD в RUB (через бэкенд)
  async convertUSDtoRUB(usdAmount) {
    try {
      console.log('🔄 Конвертация USD в RUB через бэкенд:', usdAmount);
      
      const result = await backendApiService.convertCurrency(usdAmount, 'USD', 'RUB');
      
      console.log('✅ Конвертация выполнена:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка конвертации валют:', error);
      // Fallback: используем примерный курс
      // Получаем курс с бэкенда
      const rates = await this.getCurrencyRates();
      if (!rates?.RUB) {
        throw new Error('Курс рубля недоступен');
      }
      const usdToRubRate = rates.RUB;
      return usdAmount * usdToRubRate;
    }
  },

  // Проверка доступности бэкенда
  async isBackendAvailable() {
    try {
      await backendApiService.healthCheck();
      return true;
    } catch (error) {
      console.warn('⚠️ Бэкенд недоступен:', error.message);
      return false;
    }
  },

  // ===============================================
  // 📊 СТАТУСЫ ПЛАТЕЖЕЙ
  // ===============================================

  // Получение текста статуса платежа
  getPaymentStatusText(status) {
    const statusMap = {
      'SUCCESS': 'Платеж успешно завершен',
      'FAILED': 'Платеж не прошел',
      'PENDING': 'Ожидание оплаты',
      'CANCELLED': 'Платеж отменен',
      'PROCESSING': 'Платеж в обработке',
      'UNKNOWN': 'Неизвестный статус'
    };
    
    return statusMap[status] || 'Неизвестный статус';
  },

  // Проверка, является ли статус успешным
  isPaymentSuccessful(status) {
    return status === 'SUCCESS';
  },

  // Проверка, является ли статус финальным
  isPaymentFinal(status) {
    return ['SUCCESS', 'FAILED', 'CANCELLED'].includes(status);
  },

  // ===============================================
  // 🔄 СОЗДАНИЕ ПЛАТЕЖА С ОТСЛЕЖИВАНИЕМ
  // ===============================================

  // Создание платежа с автоматическим отслеживанием и прогрессом
  async createPaymentWithTracking(steamAccount, amount, currency, onProgress) {
    try {
      console.log('🔄 СОЗДАНИЕ ПЛАТЕЖА С ОТСЛЕЖИВАНИЕМ:', {
        steamAccount: steamAccount,
        amount: amount,
        currency: currency,
        timestamp: new Date().toISOString()
      });
      
      // Симулируем прогресс создания QR-кода
      if (onProgress) {
        onProgress(10, 'Подготовка данных...');
        await new Promise(resolve => setTimeout(resolve, 500));
        
        onProgress(30, 'Создание QR-кода...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        onProgress(60, 'Генерация ссылки...');
        await new Promise(resolve => setTimeout(resolve, 500));
        
        onProgress(90, 'Финальная настройка...');
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      
      // Создаем QR-код через бэкенд (orderId генерируется на бэкенде)
      const result = await this.createQRCode(amount, steamAccount);
      
      if (result.success) {
        // Проверяем, не является ли это существующим заказом
        if (result.qrCode === 'existing_order') {
          console.log('⚠️ Заказ уже существует, используем существующие данные');
          return {
            success: true,
            qrCode: 'existing_order',
            paymentUrl: 'existing_order',
            orderId: result.orderId,
            invoiceGuid: result.invoiceGuid,
            paymentGuid: result.paymentGuid,
            delay: 0,
            message: 'Заказ уже существует'
          };
        }
        
        console.log('✅ Платеж с отслеживанием создан успешно');
        return {
          success: true,
          qrCode: result.qrCode,
          paymentUrl: result.paymentUrl,
          orderId: result.orderId, // Получаем orderId с бэкенда
          invoiceGuid: result.invoiceGuid,
          paymentGuid: result.paymentGuid,
          delay: 2.3 // Примерное время создания
        };
      } else {
        throw new Error(result.message || 'Ошибка создания платежа');
      }
      
    } catch (error) {
      console.error('❌ Ошибка создания платежа с отслеживанием:', error);
      return {
        success: false,
        message: 'Ошибка создания платежа с отслеживанием',
        error: error.message
      };
    }
  },

  // ===============================================
  // 🔄 ПОЛЛИНГ СТАТУСА
  // ===============================================

  // Поллинг статуса платежа с таймаутом
  async pollPaymentStatus(paymentGuid, maxAttempts = 30, interval = 2000) {
    console.log('🔄 Начинаем поллинг статуса платежа:', paymentGuid);
    
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        console.log(`📡 Попытка ${attempt}/${maxAttempts} проверки статуса...`);
        
        const result = await this.checkPaymentStatus(paymentGuid);
        
        if (result.success) {
          console.log('✅ Статус получен:', result.status);
          
          // Если статус финальный, прекращаем поллинг
          if (this.isPaymentFinal(result.status)) {
            return result;
          }
        }
        
        // Ждем перед следующей попыткой
        if (attempt < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, interval));
        }
        
      } catch (error) {
        console.error(`❌ Ошибка попытки ${attempt}:`, error);
        
        // Если это последняя попытка, возвращаем ошибку
        if (attempt === maxAttempts) {
          throw error;
        }
        
        // Ждем перед следующей попыткой
        await new Promise(resolve => setTimeout(resolve, interval));
      }
    }
    
    // Если достигли максимального количества попыток
    throw new Error('Превышено время ожидания статуса платежа');
  }
};

export default sbpService;
